import React from 'react'
import { Link } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai'
import { BsLink45Deg } from 'react-icons/bs'


const Menu = () => {

  const handleSubMenu = (e) => {
    if (e.target.classList.contains('active')) {
      e.target.classList.remove('active');
      e.target.parentElement.classList.remove('active');
    } else {
      e.target.classList.add('active')
      e.target.parentElement.classList.add('active');
    }
  }

  return (
    <div className='mt-8'>
      <ul>
        <li>
          <Link to="/" className='menu active !dark:bg-black'> <span><AiOutlineHome /></span> Home </Link>
        </li>
        <li>
          <button onClick={handleSubMenu} className='menu w-full font-medium'><span><AiOutlineHome /></span>Booking</button>
          <div className='sub-menu'>
            <Link to="/booking/all-booking" className='menu !pl-12'> All Booking </Link>
            <Link to="/booking/add-booking" className='menu !pl-12'> Add Booking </Link>
          </div>
        </li>
        <li>
          <button onClick={handleSubMenu} className='menu w-full font-medium'><span><AiOutlineHome /></span>Booking</button>
          <div className='sub-menu'>
            <Link to="/booking/all-booking" className='menu !pl-12'> All Booking </Link>
            <Link to="/booking/add-booking" className='menu !pl-12'> Add Booking </Link>
          </div>
        </li>
        <li>
          <button onClick={handleSubMenu} className='menu w-full font-medium'><span><AiOutlineHome /></span>Project</button>
          <div className='sub-menu'>
            <Link to="/project/all-project" className='menu !pl-12'> All Project </Link>
            <Link to="/project/add-project" className='menu !pl-12'> Add Project </Link>
          </div>
        </li>
        <li>
          <Link to="/contact" className='menu  !dark:bg-black'> <span><BsLink45Deg /></span>Contact </Link>
        </li>      
      </ul>
    </div>
  )
}


export default Menu;